exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-2c228aa1]{background-color:#d9d9d9}\n", ""]);

// exports
